import Integrations from './integrations';

export default {
  Integrations,
};
